<div>
	<div class="top-section">
		<div class="card-button-group">
			<button class="button-general" [disabled]="checkDiscardDisable()" (click)="discard()">Discard</button>
			<button class="button-general" [title]="commitDisableReason" [disabled]="checkCommitDisabled()" (click)="commit()">Commit</button>
		</div>
	</div>
	<div class="content-section">
		<div class="filter-types">
			<div class="filter-type-item" *ngFor="let filterType of filterTypes">
				<input name="filter-type" type="radio" [(ngModel)]="selectedFilterType" [value]="filterType">
				<label>{{filterType.label}}: {{filterType.count}}</label>
			</div >
		</div>
		<!-- <div class="archive-toggle">
			<app-feat-archive-mode></app-feat-archive-mode>
		</div> -->
		<div class="clause-list">
			<div *ngFor="let clause of editClauses; let idx = index;" class="clause-item">
				<div class="clause-operations">
					<div *ngIf="idx > 0" class="remove-clause" (click)="removeClause(idx)">
						<i class="glyphicons glyphicons-minus-sign"></i>
					</div>
				</div>
				<div class="clause-body">
					<div class="clause-body-part1">
						<div class="clause-col">
							<select name="clause-{{idx}}" [(ngModel)]="clause.col" (ngModelChange)="onSelectCol(idx)" style="width:100%;">
								<ng-container *ngFor="let col of columns">
									<option *ngIf="!col.hideFromEditing" [ngValue]="col">{{col.name}}</option>
								</ng-container>
							</select>
						</div>
						<div class="clause-operator">{{clause.operator}}</div>
					</div>
					<div class="clause-body-part2">
						<div class="clause-val">
							<input *ngIf="!clause.col" name="clause-col-{{idx}}">
							<ng-container *ngIf="clause.col&&clause.col.standardName!==nguidStandardName">
								<app-feat-edit-cell
									[(cellValue)]="clause.val"
									[column]="clause.col"
									[isEditDisabled]="clause.col.standardName.toLowerCase()===discrepancyIdStandardNameLower"
									[domainsByColumn]="domainsByColumn"
									[standardColName]="clause.col.standardName"
									[inputPlaceholder]="getPlaceholder(clause.col)"
									[cssClass]="{'invalid-clause': !clause.isValid}"
									(valueChange)="onInputVal(idx, $event.type)"
								></app-feat-edit-cell>
								<!-- 
									(blur)="checkClauseValidity_input(idx)"
									(enter)="checkClauseValidity_input(idx)"
								 -->
							</ng-container>
							<app-feat-config-nguid *ngIf="clause.col&&clause.col.standardName===nguidStandardName" [calculateOnly]="true" (onClickCompute)="computeNguid()"></app-feat-config-nguid>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="add-clause" title="Add a new expression" (click)="addNewEditClause()">
				<i class="glyphicons glyphicons-plus-sign"></i>
			</div>
		</div>
	</div>
</div>